import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { afterItems, beforeItems } from '../../data/content';
export function BeforeAfterSection() {
  return <section aria-labelledby="compare-heading" className="bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-56" data-mp="1xotspxz95xp4">
      <div className="mx-auto max-w-5xl" data-id="element-57" data-mp="22nohdgjwigh5">
        <SectionHeading id="compare-heading" title={<>
              From Overwhelmed Instructor to <Accent data-id="element-59" data-mp="1srbryuve2os7">Organized Educator</Accent>
            </>} data-id="element-58" data-mp="22qsrsvnym8g9" />

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-60" data-mp="1ezdkspl8n2yo">
          <div className="rounded-[20px] bg-brand-ivory/70 p-7 sm:p-9" data-id="element-61" data-mp="1f0yfqgbgsnx2">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-charcoal/55" data-id="element-62" data-mp="1jzjl0u5kpxsd">Before</h3>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-63" data-mp="151r540w477dn">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-brand-charcoal/60" data-id="element-64" data-mp="19zslge25oslf">
                  <XIcon className="mt-0.5 h-4 w-4 flex-none text-[#B5655E]" strokeWidth={2.25} aria-hidden="true" data-id="element-65" data-mp="279tanepx58u0" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-[20px] border-2 border-brand-cta/40 bg-white p-7 shadow-[0_30px_60px_-40px_rgba(30,82,54,0.55)] sm:p-9" data-id="element-66" data-mp="2g62b8wpmudhq">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-cta" data-id="element-67" data-mp="1ogfr05rnootp">
              After
            </h3>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-68" data-mp="1jjyxew1oti98">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3 text-[15px] font-medium leading-snug text-brand-charcoal" data-id="element-69" data-mp="1xbnbh4vhygsu">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-70" data-mp="14t87xunkiv9a" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}